export class InternalAuditTemplateUserDTO {
  internalAuditTemplateId!: number;

  userId!: string;

  role!: number;
}

export default class InternalAuditTemplateDTO {
  tenantId!: string;

  internalAuditTemplateId!: number;

  name!: string;

  description?: string;

  auditType!: number;

  ownerId?: string;

  ownerRoleId?: string;

  authSchemaId?: number;

  // MSRecurrence JSON; its range start date is the series start (there is no separate field)
  recurrencePattern?: string;

  // optional event template whose subtasks are the procedure library for the execution phase
  taskTemplateId?: number;

  // read-only, derived: the series carries a saved setup (default scope items). Only filled on
  // the single-template reads; the list reads leave it undefined
  hasSetup?: boolean;

  // read-only, server-owned: the audit whose setup was last saved to this series, and when;
  // cleared when the series scope is edited by hand
  setupSourceInternalAuditId?: number;

  setupSavedOn?: string;

  auditTrailId!: number;

  modified!: string;

  users!: InternalAuditTemplateUserDTO[];

  // the standards (tenant norm ids) the series audits against. Undefined on a write = not sent =
  // untouched; an empty list is refused (AUDIT0027). Undefined on a read when the read did not load it
  normIds?: number[];
}

export class InternalAuditScheduleDTO {
  template!: InternalAuditTemplateDTO;

  occurrences!: InternalAuditScheduleOccurrenceDTO[];

  calculatedDates!: string[];
}

export class InternalAuditScheduleOccurrenceDTO {
  internalAuditId!: number;

  name!: string;

  status!: number;

  origin!: number;

  startDate?: string;

  endDate?: string;

  scopeItemCount!: number;
}
